const PREFIX = 'fggg_';

function safeJsonParse(value) {
  if (value === null || value === undefined) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export const storage = {
  config: {
    get(key) {
      const value = localStorage.getItem(`${PREFIX}cfg_${key}`);
      return safeJsonParse(value);
    },
    set(key, value) {
      localStorage.setItem(`${PREFIX}cfg_${key}`, JSON.stringify(value));
    },
    remove(key) {
      localStorage.removeItem(`${PREFIX}cfg_${key}`);
    },
  },
  game: {
    get(key) {
      const value = sessionStorage.getItem(`${PREFIX}game_${key}`);
      return safeJsonParse(value);
    },
    set(key, value) {
      sessionStorage.setItem(`${PREFIX}game_${key}`, JSON.stringify(value));
    },
    remove(key) {
      sessionStorage.removeItem(`${PREFIX}game_${key}`);
    },
  },
};
